import '../styles/index.scss'

import Load from './utils/load'
import Scroll from './utils/scroll'
import Menu from './components/menu'
import Hero from './components/hero'
import Passenger from './components/passenger'
import Pilot from './components/pilot'
import Event from './components/event'
import Gallery from './components/gallery'
import Contact from './components/contact'

export const URL = "https://airfieldlacaminera.com"
export const API = "https://airfieldlacaminera.com/api/wp-json/wp/v2"

import './pages/home'
import './components/button'
import './components/testimonial'
import './components/package'

const scroll = new Scroll()

scroll.stop()
new Load({ domElement: document.querySelector('.preload'), scroll })
new Menu()
new Hero()
new Contact()
new Passenger({ scroll })
new Pilot({ scroll })
new Event({ scroll })
new Gallery({ scroll })
